import React from 'react';
import { Image } from 'lucide-react';

interface ServiceImagePlaceholderProps {
  serviceName: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export const ServiceImagePlaceholder = ({
  serviceName,
  className = '',
  size = 'md',
  isLoading = false
}: ServiceImagePlaceholderProps) => {
  // Determine icon size based on the size prop
  const iconSize = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10'
  }[size];

  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <img 
        src="/lovable-uploads/7133a723-9f56-4e76-92c5-6a1d9fb3cf12.png" 
        alt={`Placeholder for ${serviceName}`} 
        className="w-full h-full object-cover object-center"
        style={{ aspectRatio: '1/1' }}
      />
      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-black/10">
        <Image className={`${iconSize} text-white/70`} />
      </div>
      <span className="sr-only">
        {isLoading ? "Loading image for " + serviceName : "Image placeholder for " + serviceName}
      </span>
    </div>
  );
};
